module.exports = __webpack_public_path__ + "img/070c8288d208c5d4ca1ee3f4d07e3ed.e966db26.jpg";